import React from 'react';
import { PlusIcon } from 'lucide-react';
import { Button } from '@mui/material';

interface TreatmentPlanCTAProps {
  onClick: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
}

const TreatmentPlanCTA: React.FC<TreatmentPlanCTAProps> = ({ onClick, disabled, fullWidth }) => {
  return (
    <div className="px-3 w-full py-4">
      <Button
        onClick={onClick}
        disabled={disabled}
        startIcon={<PlusIcon />}
        variant="contained"
        color="primary"
        fullWidth={fullWidth}
        sx={{ minWidth: fullWidth ? 'fit-content' : '100%' }}
      >
        <p className="text-[0.9375rem] font-medium">New Treatment Plan</p>
      </Button>
    </div>
  );
};

export default TreatmentPlanCTA;
